/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { createContext, useState } from 'react';

interface SidebarContextProps {
    currentOpenMenuItem: string[];
    setCurrentOpenItem: React.Dispatch<React.SetStateAction<string[]>>;
    lastUpdatedStats: number;
    setLastUpdatedStats: React.Dispatch<React.SetStateAction<number>>;
}

export const SidebarContext = createContext<SidebarContextProps>({
    currentOpenMenuItem: [],
    setCurrentOpenItem: () => {},
    lastUpdatedStats: Date.now(),
    setLastUpdatedStats: () => {},
});

export const SidebarProvider: React.FC<React.PropsWithChildren<any>> = ({
    children,
}) => {
    const [currentOpenMenuItem, setCurrentOpenItem] = useState<string[]>([]);
    const [lastUpdatedStats, setLastUpdatedStats] = useState<number>(
        Date.now()
    );

    return (
        <SidebarContext.Provider
            value={{
                currentOpenMenuItem,
                setCurrentOpenItem,
                lastUpdatedStats,
                setLastUpdatedStats,
            }}
        >
            {children}
        </SidebarContext.Provider>
    );
};
